import React from 'react';
import styled from 'styled-components';
import { COLORS } from 'config/theme';

export const StyledTitle = styled.h4`
  margin: 0 0 10px;
  color: ${COLORS.primaryColor};
  font-size: 21px;
  font-weight: 400;
  letter-spacing: 0.3px;
`;

const Title = ({ children }) => {
  return (
    <StyledTitle>
      {children}
    </StyledTitle>
  );
};

export default Title;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Warehouses/Title.jsx